export enum PhxDataTableSelectallMode {
  AllPages = 'allPages',
  Page = 'page',
}
